<template>
    <div class="ReportsPane">
        <div class="container-fluid container-fill">
            <div class="row">
                <h2>Downloadable Reports</h2>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <h4>OCAP</h4>
                    <!--OCAP-->
                    <ReportDownloader report-label="OCAP"
                                      endpoint=""
                                      :parameter-schema="ParamsSubProgramTerritoryTargetDate"
                                      report-description="" />
                </div>
                <div class="col-md-4">
                    <h4>IMR</h4>
                    <!--IMR-->
                    <ReportDownloader report-label="IMR"
                                      endpoint=""
                                      :parameter-schema="ParamsSubProgramTerritoryStatusType"
                                      report-description="" />
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    //import components
    import ReportDownloader from '../../Core/UI/ReportDownloader.vue';

    export default {
        props: [],
        name: "ReportsPane",
        data: function () {
            return {
                ParamsSubProgramTerritoryTargetDate: [
                    {
                        Label: "Program:",
                        Name: "SubProgramID",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Territory:",
                        Name: "SubProgramTerritoryID",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Target Date:",
                        Name: "TargetDate",
                        Type: "Date",
                        Required: true
                    }
                ],
                ParamsSubProgramTerritoryStartEndDate: [
                    {
                        Label: "Program:",
                        Name: "SubProgramID",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Territory:",
                        Name: "SubProgramTerritoryID",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    }
                ],
                ParamsSubProgramTerritoryStatusType: [
                    {
                        Label: "Program:",
                        Name: "SubProgramID",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Territory:",
                        Name: "SubProgramTerritoryID",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Status:",
                        Name: "Status",
                        Type: "Select",
                        Required: true,
                        Options: [
                            {
                                text: "All",
                                value: "All"
                            },
                            {
                                text: "Approved",
                                value: "Approved"
                            },
                            {
                                text: "Coordinator",
                                value: "Coordinator"
                            },
                            {
                                text: "In Training",
                                value: "In Training"
                            },
                            {
                                text: "No App Form",
                                value: "No App Form"
                            },
                            {
                                text: "No Roles",
                                value: "No Roles"
                            },
                            {
                                text: "On Hold",
                                value: "On Hold"
                            },
                            {
                                text: "RF Exclusive",
                                value: "RF Exclusive"
                            },
                            {
                                text: "Switched Off",
                                value: "Switched Off"
                            },
                            {
                                text: "Under 16",
                                value: "Under 16"
                            },
                        ]
                    },
                    {
                        Label: "Family Type:",
                        Name: "FamilyType",
                        Type: "Select",
                        Required: true,
                        Options: [
                            {
                                text: "All",
                                value: "All"
                            },
                            {
                                text: "Host Families",
                                value: "Host"
                            },
                            {
                                text: "Family Friends",
                                value: "Friend"
                            },
                            {
                                text: "Champions",
                                value: "Champion"
                            }
                        ]
                    },
                ]
            };
        },
        methods: {

        },
        computed: {
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            },
            SubProgramTerritoryOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramTerritoryOptions"]();
            },
        },
        components: {
            ReportDownloader
        },
        mounted() {
            //ParamsSubProgramTerritoryTargetDate
            this.ParamsSubProgramTerritoryTargetDate[0].Options = this.SubProgramOptions;
            this.ParamsSubProgramTerritoryTargetDate[1].Options = [{text: "All", value: null}];
            this.ParamsSubProgramTerritoryTargetDate[1].Options = this.ParamsSubProgramTerritoryTargetDate[1].Options.concat(this.SubProgramTerritoryOptions);

            //ParamsSubProgramTerritoryStartEndDate
            this.ParamsSubProgramTerritoryStartEndDate[0].Options = this.SubProgramOptions;
            this.ParamsSubProgramTerritoryStartEndDate[1].Options = [{ text: "All", value: null }];
            this.ParamsSubProgramTerritoryStartEndDate[1].Options = this.ParamsSubProgramTerritoryStartEndDate[1].Options.concat(this.SubProgramTerritoryOptions);


            //ParamsSubProgramTerritoryStatusType
            this.ParamsSubProgramTerritoryStatusType[0].Options = this.SubProgramOptions;
            this.ParamsSubProgramTerritoryStatusType[1].Options = [{ text: "All", value: null }];
            this.ParamsSubProgramTerritoryStatusType[1].Options = this.ParamsSubProgramTerritoryStatusType[1].Options.concat(this.SubProgramTerritoryOptions);
        }
    }
</script>